import { Component, Input, OnInit } from '@angular/core';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';

@Component({
  selector: 'app-LetterRequestCustomerReview',
  templateUrl: './LetterRequestCustomerReview.component.html',
  styleUrls: ['./LetterRequestCustomerReview.component.scss']
})
export class LetterRequestCustomerReviewComponent implements OnInit {


  @Input() inner_Letter_id: number = 0
  Token: String = ""
  InProccessing: boolean = false

  s1:string=""
  s1_1:string=""
  s1_2:string=""
  s2:string=""
  s3:string=""
  s4:string=""
  s5:string=""
  s6:string=""
  s7:string=""
  s8:string=""
  s9:string=""

  constructor(
    private LetterRequestCustomer_Service: LetterRequestCustomerService,
    private Alertify_Service: AlertifyService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.GetRecord()
  }

  GetRecord(){
    this.InProccessing=true
    this.LetterRequestCustomer_Service.GetReview(this.inner_Letter_id,this.Token).subscribe(
      data=>{
        this.InProccessing=false
        this.s1=data['s1']
        this.s1_1=data['s1_1']
        this.s1_2=data['s1_2']
        this.s2=data['s2']
        this.s3=data['s3']
        this.s4=data['s4']
        this.s5=data['s5']
        this.s6=data['s6']
        this.s7=data['s7']
        this.s8=data['s8']
        this.s9=data['s9']
      }
    )
  }

  OnSubmit()
  {
    this.InProccessing=true
    this.LetterRequestCustomer_Service.PostReview(
      this.inner_Letter_id,
      this.s1,
      this.s1_1,
      this.s1_2,
      this.s2,
      this.s3,
      this.s4,
      this.s5,
      this.s6,
      this.s7,
      this.s8,
      this.s9,
      this.Token).subscribe(
        data=>{
          this.InProccessing=false
          this.Alertify_Service.SuccessMessage("The information was saved successfully.")
        }
      )
  }

}
